import { types } from "../../types/types";
import { handleErrorApi } from "../../helpers/randoms";
import { finishSpinner, startSpinner } from "../ui/spinner";
import { LiquidacionesService } from "../../services/LiquidacionesService";
import { LIQUIDACIONES_COMPROBANTES_ESTADOS, LIQUIDACIONES_LINEA_COMPORBANTE } from "../../utils/constants";
import { startAlerta } from "../ui/alertas";

const baseUrl = process.env.REACT_APP_API_URL;

export const setEstadoComprobantes = (estado) => {
  return {
    type: types.liquidacionesUpdateEstadoComprobantes,
    payload: estado,
  };
};

export const setEfectorSeleccionado = (efector) => {
  return {
    type: types.liquidacionesSetEfectorSeleccionado,
    payload: efector,
  };
};

export const cleanEfectorSeleccionado = () => {
  return { type: types.liquidacionesCleanEfectorSeleccionado };
};

export const setAfiliadoSeleccionado = (afiliado) => {
  return {
    type: types.liquidacionesSetAfiliadoSeleccionado,
    payload: afiliado,
  };
};

export const cleanAfiliadoSeleccionado = () => {
  return { type: types.liquidacionesCleanAfiliadoSeleccionado };
};

export const clearReducer = () => {
  return { type: types.liquidacionesClearReducer };
};

export const cleanComprobantes = () => ({ type: types.liquidacionesCleanComprobantes });

export const setComprobanteSeleccionado = (item) => {
  return {
    type: types.liquidacionesSetComprobanteSeleccionado,
    payload: item,
  };
};

export const cleanComprobanteSeleccionado = () => ({ type: types.liquidacionesCleanComprobanteSeleccionado });

export const cleanComprobantesTomados = () => {
  return { type: types.liquidacionesComprobantesTomadosLimpiar };
};

// export const getComprobantesGestion = (
//   idEfectorFacturacion,
//   fechaDesde,
//   fechaHasta,
//   idEstadoSolicitud
// ) => {
//   return async (dispatch) => {
//     try {
//       dispatch(startSpinner());
//       const result = await LiquidacionesService.getComprobantesGestion(
//         idEfectorFacturacion,
//         fechaDesde,
//         fechaHasta,
//         idEstadoSolicitud
//       );
//       const body = await result.json();
//       if (result.ok) {
//         dispatch({
//           type: types.liquidacionesGetComprobantesSuccess,
//           payload: body,
//         });
//       } else {
//         throw body;
//       }
//       dispatch(finishSpinner());
//     } catch (error) {
//       dispatch(finishSpinner());
//       dispatch({ type: types.liquidacionesGetComprobantesError });
//       handleErrorApi(
//         dispatch,
//         error,
//         "Error al obtener los Comprobantes",
//         "Ha ocurrido un error. Intente nuevamente"
//       );
//     }
//   };
// };

export const getContadoresLiquidacionesGestion = (
  idEfectorFacturacion,
  fechaDesde,
  fechaHasta,
  idEstadoSolicitud,
  idComprobante
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.getContadoresLiquidacionesGestion(
        idEfectorFacturacion,
        fechaDesde,
        fechaHasta,
        idEstadoSolicitud,
        idComprobante
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.liquidacionesGetContadoresComprobantesSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.liquidacionesGetContadoresComprobantesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los contadores de los comprobantes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getComprobantesContadoresGestion = (
  idEfectorFacturacion,
  fechaDesde,
  fechaHasta,
  idEstadoSolicitud,
  idComprobante
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      await Promise.all([
        idEstadoSolicitud
          ?
          LiquidacionesService.getComprobantesGestion(
            idEfectorFacturacion,
            fechaDesde,
            fechaHasta,
            parseInt(idEstadoSolicitud),
            idComprobante
          )
          :
          null
        ,
        LiquidacionesService.getContadoresLiquidacionesGestion(
          idEfectorFacturacion,
          fechaDesde,
          fechaHasta,
          parseInt(idEstadoSolicitud),
          idComprobante
        )
      ]).then(async ([resultComprobantes, resultContadores]) => {
        const bodyContadores = await resultContadores.json();
        if (resultContadores.ok) {
          dispatch({
            type: types.liquidacionesGetContadoresComprobantesSuccess,
            payload: bodyContadores,
          });
        } else {
          throw bodyContadores;
        }

        const bodyComprobantes = idEstadoSolicitud ? await resultComprobantes.json() : null;
        if (resultComprobantes?.ok) {
          dispatch({
            type: types.liquidacionesGetComprobantesSuccess,
            payload: bodyComprobantes,
          });
        } else {
          if (idEstadoSolicitud) {
            throw bodyComprobantes;
          }
        }
      })
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.liquidacionesGetComprobantesContadoresError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los Comprobantes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//LINEAS PRESTACION COMPROBANTE
export const getLineasPrestacion = (
  idComprobante,
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.getLineasPrestacion(
        idComprobante
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.liquidacionesGetLineasPrestacionComprobanteSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.liquidacionesGetLineasPrestacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las Líneas del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const addLineaPrestacion = (linea) => {
  return { type: types.liquidacionesAddLineaPrestacionComprobante, payload: linea };
};

export const insertLineaPrestacion = (
  idComprobante,
  fechaPrestacion,
  idCodNomA,
  cantidad,
  importe,
  idAfiliado,
  idCategoria,
  fechaInternacionDesde,
  fechaInternacionHasta,
  nroValidacion,
  idSolicitud,
  afiliadoInexistente,
  soloPrecarga,
  coseguroFacturado,
  practicaInexistente,
  idAfiliadoExterno,
  closeModal,
  comentarioCausa,
  idMotivoDebito
  // idAgenda,
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const idCodNom = idCodNomA ? idCodNomA : null
      const result = await LiquidacionesService.insertLineaPrestacion(
        {
          idComprobante,
          fechaPrestacion,
          idCodNom,
          cantidad,
          importe,
          idAfiliado,
          idCategoria,
          fechaInternacionDesde,
          fechaInternacionHasta,
          nroValidacion,
          idSolicitud,
          afiliadoInexistente,
          coseguroFacturado,
          practicaInexistente,
          comentarioCausa,
          idMotivoDebito,
          idAfiliadoExterno
          // idAgenda,
        }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: soloPrecarga
            ? types.liquidacionesUpdateLineaNuevaPrestacionComprobante
            : types.liquidacionesAddLineaPrestacionComprobante,
          payload: body,
        });
        dispatch(getTotalLineasComprobante(idComprobante));
        dispatch(
          startAlerta(
            `Ingresada correctamente`,
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.liquidacionesGetLineasPrestacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener insertar la Línea del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const modificarLineaPrestacion = (
  idItem,
  idComprobante,
  fechaPrestacion,
  idCodNomA,
  cantidad,
  importe,
  idAfiliado,
  afiliadoInexistente,
  idSolicitud,
  idCategoria,
  coseguroFacturado,
  practicaInexistente,
  nroValidacion,
  setImporteDebito,
  importeDebito,
  idAfiliadoExterno
  // idAgenda,
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const idCodNom = idCodNomA ? idCodNomA : null
      const result = await LiquidacionesService.modificarLineaPrestacion(
        {
          idItem,
          idComprobante,
          fechaPrestacion,
          idCodNom,
          cantidad,
          importe,
          idAfiliado,
          afiliadoInexistente,
          idSolicitud,
          idCategoria,
          coseguroFacturado,
          practicaInexistente,
          nroValidacion,
          idAfiliadoExterno
        }
      );
      const body = await result.json();
      debugger
      if (result.ok) {
        dispatch({
          type: types.liquidacionesUpdateLineaPrestacionComprobante,
          payload: body,
        });
        if (setImporteDebito && importeDebito !== body.importeDebito)
          setImporteDebito(body.importeDebito);
        dispatch(getTotalLineasComprobante(idComprobante));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.liquidacionesGetLineasPrestacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener insertar la Línea del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteLineaPrestacion = (
  idItem,
  idCodNom,
  idComprobante,
  idAfiliado,
  afiliadoInexistente,
  practicaInexistente
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.deleteLineaPrestacion(
        {
          idItem,
          idCodNom,
          idComprobante,
          idAfiliado,
          afiliadoInexistente,
          practicaInexistente
        }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.liquidacionesDeleteLineaPrestacionComprobante,
          payload: idItem,
        });
        dispatch(getTotalLineasComprobante(idComprobante));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.liquidacionesGetLineasPrestacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener eliminar la Línea del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteLineaPrestacionMasiva = (
  idComprobante
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.deleteLineaPrestacionMasiva(
        {
          idComprobante,
        }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(cleanLineasPrestacion());
        dispatch(getTotalLineasComprobante(idComprobante));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.liquidacionesGetLineasPrestacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener eliminar la Línea del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteLineaPrestacionNoGrabada = (idItem) => {
  return {
    type: types.liquidacionesDeleteLineaPrestacionComprobante,
    payload: idItem,
  };
};

export const updateLineaPrestacion = (
  idItem,
  idComprobante,
  importe,
  importeDebito,
  fechaPrestacion,
  comentario,
  setOpenModalNota,
  setImporteDebito,
  idCodNom,
  afiliadoInexistente,
  practicaInexistente,
  comentarioCausa,
  idMotivoDebito,
) => {
  return async (dispatch) => {
    try {
      debugger
      dispatch(startSpinner());
      const result = await LiquidacionesService.updateLineaPrestacion(
        {
          idItem,
          idComprobante,
          importe,
          importeDebito,
          fechaPrestacion,
          comentario,
          idCodNom,
          afiliadoInexistente,
          practicaInexistente,
          comentarioCausa,
          idMotivoDebito
        }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.liquidacionesUpdateLineaPrestacionComprobante,
          payload: body,
        });
        if (setImporteDebito && importeDebito !== body.importeDebito)
          setImporteDebito(body.importeDebito);
        setOpenModalNota && setOpenModalNota(false);
        dispatch(getTotalLineasComprobante(idComprobante));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.liquidacionesGetLineasPrestacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al actualizar la Línea del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const cleanLineasPrestacion = () => {
  return { type: types.liquidacionesCleanLineasPrestacionComprobante };
};

//LINEAS INSUMO COMPROBANTE
export const getLineasInsumos = (
  idComprobante,
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.getLineasInsumos(
        idComprobante
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.liquidacionesGetLineasInsumosComprobanteSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.liquidacionesGetLineasInsumosError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las Líneas del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const addLineaInsumos = (linea) => {
  return { type: types.liquidacionesAddLineaInsumoComprobante, payload: linea };
};

export const insertLineaInsumo = (
  idComprobante,
  fechaPrestacion,
  idMaterial,
  cantidad,
  importe,
  idAfiliado,
  fechaInternacionDesde,
  fechaInternacionHasta,
  nroValidacion,
  idSolicitud,
  afiliadoInexistente,
  soloPrecarga
  // idAgenda,
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.insertLineaInsumo(
        {
          idComprobante,
          fechaPrestacion,
          idMaterial,
          cantidad,
          importe,
          idAfiliado,
          fechaInternacionDesde,
          fechaInternacionHasta,
          nroValidacion,
          idSolicitud,
          afiliadoInexistente,
          // idAgenda,
        }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: soloPrecarga
            ? types.liquidacionesUpdateLineaNuevaInsumoComprobante
            : types.liquidacionesAddLineaInsumoComprobante,
          payload: body,
        });
        dispatch(getTotalLineasComprobante(idComprobante));
        dispatch(
          startAlerta(
            `Ingresada correctamente`,
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.liquidacionesGetLineasInsumosError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener insertar la Línea del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteLineaInsumo = (
  idItem,
  idMaterial,
  idComprobante,
  idAfiliado,
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.deleteLineaInsumo(
        {
          idItem,
          idMaterial,
          idComprobante,
          idAfiliado,
        }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.liquidacionesDeleteLineaInsumoComprobante,
          payload: idItem,
        });
        dispatch(getTotalLineasComprobante(idComprobante));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.liquidacionesGetLineasInsumosError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener eliminar la Línea del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteLineaInsumoMasiva = (
  idComprobante
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.deleteLineaInsumoMasiva(
        {
          idComprobante
        }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(cleanLineasInsumos());
        dispatch(getTotalLineasComprobante(idComprobante));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.liquidacionesGetLineasInsumosError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener eliminar la Línea del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteLineaInsumoNoGrabada = (idItem) => {
  return {
    type: types.liquidacionesDeleteLineaInsumoComprobante,
    payload: idItem,
  };
};

export const modificarLineaInsumo = (
  idItem,
  idComprobante,
  fechaPrestacion,
  idMaterial,
  cantidad,
  importe,
  idAfiliado,
  nroValidacion,
  idSolicitud,
  afiliadoInexistente,
  importeDebito,
  setImporteDebito
  // idAgenda,
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.modificarLineaInsumo(
        {
          idItem,
          idComprobante,
          fechaPrestacion,
          idMaterial,
          cantidad,
          importe,
          idAfiliado,
          nroValidacion,
          idSolicitud,
          afiliadoInexistente,
        }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.liquidacionesUpdateLineaInsumoComprobante,
          payload: body,
        });
        if (setImporteDebito && importeDebito !== body.importeDebito)
          setImporteDebito(body.importeDebito);
        dispatch(getTotalLineasComprobante(idComprobante));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.liquidacionesGetLineasInsumosError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener insertar la Línea del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const updateLineaInsumo = (
  idItem,
  idComprobante,
  importe,
  importeDebito,
  fechaPrestacion,
  comentario,
  afiliadoInexistente,
  setOpenModalNota
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.updateLineaInsumo(
        {
          idItem,
          idComprobante,
          importe,
          importeDebito,
          fechaPrestacion,
          afiliadoInexistente,
          comentario
        }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.liquidacionesUpdateLineaInsumoComprobante,
          payload: body,
        });
        setOpenModalNota && setOpenModalNota(false);
        dispatch(getTotalLineasComprobante(idComprobante));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.liquidacionesGetLineasPrestacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al actualizar la Línea del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const cleanLineasInsumos = () => {
  return { type: types.liquidacionesCleanLineasInsumosComprobante };
};

//LINEAS MEDICAMENTO
export const getLineasMedicamento = (
  idComprobante,
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.getLineasMedicamento(
        idComprobante
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.liquidacionesGetLineasMedicamentosComprobanteSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.liquidacionesGetLineasMedicamentosError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las Líneas del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const cleanLineasMedicamento = () => {
  return { type: types.liquidacionesCleanLineasMedicamentosComprobante };
};

//LINEAS COMPROBANTE
export const getTotalDebitosLineasComprobante = (
  idComprobante,
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.getTotalDebitosLineasComprobante(
        idComprobante
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.liquidacionesUpdateTotalDebitosLineasComprobanteSeleccionado,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al traer el importe de las lineas del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getTotalLineasComprobante = (
  idComprobante,
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.getTotalLineasComprobante(
        idComprobante
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.liquidacionesUpdateTotalLineasComprobanteSeleccionado,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al traer el importe de las lineas del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const insertLineasPorIdSolicitud = (
  idComprobante,
  idTipoSolicitudLinea,
  idSolicitud,
  closeModal
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.insertLineasPorIdSolicitud(
        {
          idTipoSolicitudLinea,
          idComprobante,
          idSolicitud
        }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            `Se agregaron ${body} Líneas correctamente`,
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(getTotalLineasComprobante(idComprobante));
        closeModal && closeModal();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.liquidacionesGetLineasPrestacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al Agregar Líneas de Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const eliminarTodasLineasComprobante = (
  idComprobante
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.deleteTodasLineasComprobante(
        idComprobante,
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            `Se eliminaron Todas las Líneas correctamente del IdComrobante: ${idComprobante}`,
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(getTotalLineasComprobante(idComprobante));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al Eliminar las Líneas del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//COMPROBANTES TOMADOS
export const getComprobantesTomadosPorUsuario = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result =
        await LiquidacionesService.getComprobantesTomadosPorUsuario();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.liquidacionesComprobantesTomadosUsuarioSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({
        type: types.liquidacionesComprobantesTomadosUsuarioError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las Comprobantes Tomados por Usuario",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getComprobantesTomados = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.getComprobantesTomados();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.liquidacionesComprobantesTomadosSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({
        type: types.liquidacionesComprobantesTomadosError,
      });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las Comprobantes Tomados",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const putLiberarComprobante = (id, userType, fromHomeScreen, setOpenAlert, item,
  setOpenModalAuditar, closeModal, idComprobante) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.putLiberarComprobante(id);
      const body = await result.json();
      if (result.ok) {
        if (userType === "currentUser") {
          dispatch({
            type: types.liquidacionesComprobantesTomadosUsuarioLiberar,
            payload: id,
          });
          dispatch({
            type: types.comprobantesTomadosLiberarTomadoPorIdComprobante,
            payload: idComprobante,
          });
          if (fromHomeScreen) {
            setOpenAlert(false);
            dispatch(postTomarComprobante(item, setOpenModalAuditar))
          }
        }
        else if (userType === "allUsers")
          dispatch({
            type: types.liquidacionesComprobantesTomadosLiberar,
            payload: id,
          });
        if (!!closeModal) closeModal();
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al liberar el Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postTomarComprobante = (comprobante, setOpenModalAuditar, setOpenAlert) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.postTomarComprobante(
        comprobante.idComprobante
      );
      const body = await result.json();
      if (result.ok) {
        if (body.idComprobante !== 0) {
          dispatch({
            type: types.liquidacionesComprobantesTomadosUsuarioAgregar,
            payload: body,
          });
          dispatch({
            type: types.liquidacionesComprobanteMarcarTomado,
            payload: { comprobante, auth: getState().auth, id: body.id },
          });
          setOpenModalAuditar(true);
          const nuevoComprobante = {
            ...comprobante,
            comprobantesTomados: comprobante.comprobantesTomados.length > 0
              ? comprobante.comprobantesTomados
              : [{ ...body }]
          }
          dispatch(setComprobanteSeleccionado(nuevoComprobante));
        }
      } else if (setOpenAlert &&
        body?.errores === "Error al tomar el Comprobante. Tiene un Comprobante tomado, debe liberarlo para tomar otro") {
        setOpenAlert(true);
      }
      else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al tomar el Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//COMPROBANTE
export const modificarEstadoComprobante = (
  idComprobante,
  idNuevoEstado,
  idEstadoAnterior,
  fechaDesde,
  fechaHasta,
  idEfectorFacturacion
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.putEstadoComprobante(
        idComprobante, idNuevoEstado
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.liquidacionesUpdateEstadoComprobanteSeleccionado,
          payload: { idComprobante, idNuevoEstado, idEstadoAnterior },
        });
        dispatch(
          startAlerta(
            "Comprobante modificado",
            "success",
            "Comando Exitoso"
          )
        );

        dispatch(
          getContadoresLiquidacionesGestion(
            idEfectorFacturacion,
            fechaDesde,
            fechaHasta,
            parseInt(idEstadoAnterior),
            idComprobante
          )
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al modificar el Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const devolucionExpMesaEntrada = (
  idComprobante,
  idNuevoEstado,
  idEstadoAnterior,
  fechaDesde,
  fechaHasta,
  idEfectorFacturacion
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.putDevolucionExpMesaEntrada(
        idComprobante, idNuevoEstado
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.liquidacionesUpdateEstadoComprobanteSeleccionado,
          payload: { idComprobante, idNuevoEstado, idEstadoAnterior },
        });
        dispatch(
          startAlerta(
            "Comprobante modificado",
            "success",
            "Comando Exitoso"
          )
        );

        dispatch(
          getContadoresLiquidacionesGestion(
            idEfectorFacturacion,
            fechaDesde,
            fechaHasta,
            parseInt(idEstadoAnterior),
            idComprobante
          )
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al modificar el Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const modificarEstadoComprobantes = (
  idsComprobantes,
  idNuevoEstado,
  setSelected,
  idEstadoAnterior,
  idEfectorFacturacion,
  fechaDesde,
  fechaHasta
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.putEstadoComprobantes(
        idsComprobantes, idNuevoEstado
      );
      const body = await result.json();
      if (result.ok) {
        setSelected([]);
        dispatch(
          startAlerta(
            "Comprobantes modificados",
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(
          getComprobantesContadoresGestion(
            idEfectorFacturacion,
            fechaDesde,
            fechaHasta,
            idEstadoAnterior
          )
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al modificar los Comprobantes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const modificarEmailEfectorComprobante = (
  idComprobante,
  emailEfector
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.putEmailEfectorComprobante(
        idComprobante, emailEfector
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.liquidacionesUpdateEmailEfectorComprobanteSeleccionado,
          payload: { idComprobante, emailEfector },
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al modificar el Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

//EDI
export const uploadArchivoEdiLiquidacionesHandler = (idComprobante, idEfectorFacturacion, file) => {
  return async (dispatch) => {
    const formData = new FormData();
    formData.append("files", file);

    dispatch(uploadArchivoEdiLiquidaciones(formData, idComprobante, idEfectorFacturacion));
  };
};

export const uploadArchivoEdiLiquidaciones = (formData, idComprobante, idEfectorFacturacion) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token") || "";
      let httpHeaders;
      if (token) {
        httpHeaders = {
          Authorization: `Bearer ${token}`,
        };
      }
      const response = await fetch(
        `${baseUrl}/FileUpload/UploadFileEdiLiquidaciones/${idComprobante}/${idEfectorFacturacion}`,
        {
          method: "POST",
          body: formData,
          headers: httpHeaders,
        }
      );

      const body = await response.json();
      if (response.ok) {
        dispatch(
          startAlerta(
            body.mensaje,
            body.error === 0 ? "success" : "error",
            body.error === 0 ? "Proceso Exitoso" : "Ocurrio un Error"
          )
        );
        // dispatch(getLineasPrestacion(idComprobante));
        //HAGO LO Q HACE EL getLineasPrestacion para evitar que cierre el spinner
        const resultLineas = await LiquidacionesService.getLineasPrestacion(
          idComprobante
        );
        const bodyLineas = await resultLineas.json();
        if (resultLineas.ok) {
          dispatch({
            type: types.liquidacionesGetLineasPrestacionComprobanteSuccess,
            payload: bodyLineas,
          });
          dispatch(getTotalLineasComprobante(idComprobante));
        } else {
          dispatch({ type: types.liquidacionesGetLineasPrestacionError });
          handleErrorApi(
            dispatch,
            null,
            "Error al obtener las Líneas del Comprobante",
            "Ha ocurrido un error. Intente nuevamente"
          );
        }
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar el documento.",
        "Ha ocurrido un error. Intente nuevamente."
      );
    }
  };
};

//TRACKING LINEA COMPROBANTE
export const getTrackingLineaComprobante = (
  idComprobante,
  idItem,
  tipoLinea
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = tipoLinea === LIQUIDACIONES_LINEA_COMPORBANTE.PRESTACION
        ? await LiquidacionesService.getTrackingLineaPrestacion(
          idComprobante, idItem
        )
        : await LiquidacionesService.getTrackingLineaInsumo(
          idComprobante, idItem
        );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.trackingLineaComprobanteSuccess,
          payload: body,
        });
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner())
      dispatch({ type: types.trackingLineaComprobanteError })
      handleErrorApi(
        dispatch,
        error,
        "Error al traer el historial",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const enviarPDFSolicitudPago = (idSolicitudPago, esDebitos, esPrestador) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.enviarPDFSolicitud(idSolicitudPago, esDebitos, esPrestador);
      if (result.ok)
        dispatch(startAlerta(`Mail enviado exitosamente`, 'success', 'Comando Exitoso'));
      else
        dispatch(
          startAlerta(
            `Ocurrio un error en el envio de mail${!esPrestador ? ', verifique email del afiliado.' : ''}`
            , 'warning'
            , '¡Error!'
          )
        );
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        "Ocurrio un error en el envío del PDF",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};


export const previsualizarSolicitudPago = (idComprobante, idTipoSolPago) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await LiquidacionesService.previsualizarSolicitudPago(
        idComprobante, idTipoSolPago
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/pdf") !== -1) {
        const body = await response.blob();
        if (response.ok) {
          dispatch(finishSpinner());
          window.open(URL.createObjectURL(body));
        } else {
          throw body;
        }
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al previsualizar la Solicitud de Pago",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const insertLineaMedicamento = (
  idComprobante,
  fechaDispensa,
  nroRegAb,
  cantidad,
  importeUnitFacturado,
  idAfiliado,
  soloPrecarga,
  afiliadoInexistente,
  debitoCapita,
  idEfectFactCapitaDesc,
  importeMedicamentoTabla
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.insertLineaMedicamento(
        {
          idComprobante,
          fechaDispensa,
          nroRegAb,
          cantidad,
          importeUnitFacturado,
          idAfiliado,
          soloPrecarga,
          afiliadoInexistente,
          debitoCapita,
          idEfectFactCapitaDesc,
          importeMedicamentoTabla
        }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: soloPrecarga
            ? types.liquidacionesUpdateLineaNuevaMedicamentoComprobante
            : types.liquidacionesAddLineaMedicamentoComprobante,
          payload: body,
        });
        dispatch(getTotalLineasComprobante(idComprobante));
        dispatch(
          startAlerta(
            `Ingresada correctamente`,
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.liquidacionesGetLineasPrestacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener insertar la Línea del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const updateLineaMedicamento = (
  idItem,
  idComprobante,
  importeUnitFacturado,
  importeMedicamentoTabla,
  porcenDto,
  importeDebito,
  fechaDispensa,
  comentario,
  afiliadoInexistente,
  debitoCapita,
  idEfectFactCapitaDesc,
  idCentroCosto,
  setOpenModalNota,
  cantidad) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.updateLineaMedicamento(
        {
          idItem,
          idComprobante,
          importeUnitFacturado,
          importeMedicamentoTabla,
          porcenDto,
          importeDebito,
          fechaDispensa,
          afiliadoInexistente,
          debitoCapita,
          idEfectFactCapitaDesc,
          idCentroCosto,
          comentario,
          cantidad
        }
      );
      const body = await result.json();
      dispatch({
        type: types.liquidacionesUpdateLineaMedicamentoComprobante,
        payload: body,
      });
      setOpenModalNota && setOpenModalNota(false);
      dispatch(getTotalLineasComprobante(idComprobante));
      dispatch(finishSpinner());
      dispatch(
        startAlerta(
          "Linea actualizada con éxito",
          "success",
          "Comando Exitoso"
        )
      );
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.liquidacionesGetLineasPrestacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al actualizar la Línea del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteLineaMedicamentoNoGrabada = (idItem) => {
  return {
    type: types.liquidacionesDeleteLineaMedicamentoComprobante,
    payload: idItem,
  };
};

export const deleteLineaMedicamento = (
  idItem,
  nroRegAB,
  idComprobante,
  idAfiliado,) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      await LiquidacionesService.deleteLineaMedicamento(
        {
          idItem,
          nroRegAB,
          idComprobante,
          idAfiliado,
        }
      );
      dispatch({
        type: types.liquidacionesDeleteLineaMedicamentoComprobante,
        payload: idItem,
      });
      dispatch(getTotalLineasComprobante(idComprobante));
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.liquidacionesGetLineasInsumosError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener eliminar la Línea del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getValorMedicamento = (nroReg, fechaDispensa, setImporteMedicTabla) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.getValorMedicamento(
        nroReg, fechaDispensa,
      );
      const body = await result.json();

      setImporteMedicTabla && setImporteMedicTabla(body.valor ?? 0);
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al buscar el valor del medicamento",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const deleteLineaMedicamentoMasiva = (
  idComprobante
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.deleteLineaMedicamentoMasiva(
        {
          idComprobante,
        }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(cleanLineasMedicamento());
        dispatch(getTotalLineasComprobante(idComprobante));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.liquidacionesGetLineasPrestacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener eliminar la Línea del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const imprimirSolicitudPago = (idTipoSolPago, idSolicitudPago) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await LiquidacionesService.imprimirSolicitudPago(
        idTipoSolPago, idSolicitudPago
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/pdf") !== -1) {
        const body = await response.blob();
        if (response.ok) {
          dispatch(finishSpinner());
          window.open(URL.createObjectURL(body));
        } else {
          throw body;
        }
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al visualizar la Solicitud de Pago",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const debitoCompletoLineasPrestaciones = (
  idComprobante,
  comentario
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.debitoCompletoLineasPrestaciones(
        {
          idComprobante,
          comentario
        }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.liquidacionesGetLineasPrestacionComprobanteSuccess,
          payload: body,
        });
        dispatch(
          startAlerta(
            "Débitos aplicados",
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(getTotalLineasComprobante(idComprobante));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.liquidacionesGetLineasPrestacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al generar los débitos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const uploadArchivoHeliosLiquidacionesHandler = (file) => {
  return async (dispatch) => {
    const formData = new FormData();
    formData.append("files", file);

    dispatch(uploadArchivoHeliosLiquidaciones(formData));
  };
};

export const uploadArchivoHeliosLiquidaciones = (formData) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token") || "";
      let httpHeaders;
      if (token) {
        httpHeaders = {
          Authorization: `Bearer ${token}`,
        };
      }
      const response = await fetch(
        `${baseUrl}/FileUpload/UploadFileHeliosLiquidaciones`,
        {
          method: "POST",
          body: formData,
          headers: httpHeaders,
        }
      );

      const body = await response.json();
      if (response.ok) {
        dispatch(
          startAlerta(
            body.mensaje,
            body.error === 0 ? "success" : "error",
            body.error === 0 ? "Proceso Exitoso" : "Ocurrio un Error"
          )
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar el documento.",
        "Ha ocurrido un error. Intente nuevamente."
      );
    }
  };
};


export const actualizarEfectorContacto = (
  idEfectorFacturacion,
  fechaDesde,
  fechaHasta,
  idEstadoSolicitud,
  idComprobante
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.getComprobantesGestion(
        idEfectorFacturacion,
        fechaDesde,
        fechaHasta,
        parseInt(idEstadoSolicitud),
        idComprobante
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.liquidacionesUpdateComprobanteContrato,
          payload: body[0],
        });
        console.log("body", body)
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los Comprobantes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getMotivosDebitos = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.getMotivosDebito();
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.liquidacionesGetMotivosDebitoSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener los motivos débitos",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const generateExcelLiquidacionesLineas = (idExpediente, idTipoConsulta) => async (dispatch, getState) => {
  dispatch(startSpinner());
  try {

    const response = await LiquidacionesService.getExcelLiquidaciones(idExpediente, idTipoConsulta);
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());
      let url = window.URL.createObjectURL(body);
      let a = document.createElement('a');
      a.href = url;
      a.download = `ExcelLineas.xlsx`;
      a.click();
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer el excel",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
}



export const generarVoucherLiq = (
  idsComprobantes,
  idEstado,
  setSelected,
  setIdSolicitudPago
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.putGenerarVoucherLiquidaciones(
        idsComprobantes, idEstado
      );
      const body = await result.json();
      const idSolicitudPago = body?.idSolicitudPago
      if (result.ok) {
        setSelected([]);
        dispatch(
          startAlerta(
            "Voucher Generado Exitosamente. ID Solicitud Pago: " + idSolicitudPago,
            "success",
            "Comando Exitoso"
          )
        );
        dispatch(
          cleanComprobantes()
        );
        setIdSolicitudPago(idSolicitudPago)
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al modificar los Comprobantes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const anularVoucherLiq = (
  idSolicitudPago,
  idEfectorFacturacion,
  fechaDesde,
  fechaHasta,
  idNuevoEstado,
  idComprobante
) => {
  return async (dispatch) => {
    debugger;
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.putAnularVoucherLiquidaciones(
        idSolicitudPago
      );
      const body = await result.json();
      var idEstadoAnterior = LIQUIDACIONES_COMPROBANTES_ESTADOS.ENVIADA_TESORERIA
      if (result.ok) {
        dispatch(
          startAlerta(
            "Voucher Anulado Exitosamente.",
            "success",
            "Comando Exitoso"
          )
        );
        dispatch({
          type: types.liquidacionesUpdateEstadoComprobanteSeleccionado,
          payload: { idComprobante, idNuevoEstado, idEstadoAnterior },
        });
        dispatch(
          getContadoresLiquidacionesGestion(
            idEfectorFacturacion,
            fechaDesde,
            fechaHasta,
            parseInt(idNuevoEstado),
            idComprobante
          )
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar la solicitud de pago",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};


export const uploadArchivoScienzaLiquidacionesHandler = (file, setArchivo) => {
  return async (dispatch) => {
    const formData = new FormData();
    formData.append("files", file);
    debugger
    var nombreArchivo = (file.name);
    dispatch(uploadArchivoScienzaLiquidaciones(formData, setArchivo, nombreArchivo));
  };
};

export const uploadArchivoScienzaLiquidaciones = (formData, setArchivo, nombreArchivo) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const token =
        localStorage.getItem("token") || sessionStorage.getItem("token") || "";
      let httpHeaders;
      if (token) {
        httpHeaders = {
          Authorization: `Bearer ${token}`,
        };
      }
      const response = await fetch(
        `${baseUrl}/FileUpload/UploadFileScienzaLiquidaciones`,
        {
          method: "POST",
          body: formData,
          headers: httpHeaders,
        }
      );
      debugger
      // const body = await response.json();
      console.log(response)
      if (response.ok) {
        dispatch(
          startAlerta(
            "Archivo Cargado Exitosamente.",
            "success",
            "Comando Exitoso"
          )
        );
        setArchivo && setArchivo(nombreArchivo)
      } else {
        dispatch(startAlerta("Ha ocurrido un error. Intente nuevamente.", "error"))
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar el documento.",
        "Ha ocurrido un error. Intente nuevamente."
      );
    }
  };
};


export const FinalizarCargaScienza = (archivo, archivo2, setArchivo, setArchivo2) => {
  return async (dispatch) => {
    try {
      debugger
      dispatch(startSpinner());
      const result = await LiquidacionesService.updateArchivosScienza(
        {
          archivo,
          archivo2
        }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            body.mensaje,
            body.error === 0 ? "success" : "error",
            body.error === 0 ? "Proceso Exitoso" : "Ocurrio un Error"
          )
        );
        setArchivo && setArchivo("");
        setArchivo2 && setArchivo2("");
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar el documento.",
        "Ha ocurrido un error. Intente nuevamente."
      );
    }
  };
};


export const updateLineaPrestacionSinCalculoCoseguro = (
  idItem,
  idComprobante

) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await LiquidacionesService.updateLineaPrestacionSinCalculoCoseguro(
        {
          idItem,
          idComprobante,
        }
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.liquidacionesUpdateLineaPrestacionComprobante,
          payload: body,
        });
        dispatch(getTotalLineasComprobante(idComprobante));
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      // dispatch({ type: types.liquidacionesGetLineasPrestacionError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener modificar la Línea del Comprobante",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};